import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyServiceOrderResponse } from '../../../../../../@shared/models/response.module';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-view-invoice-modal',
  standalone: false,
  templateUrl: './view-invoice-modal.html',
  styleUrl: './view-invoice-modal.css'
})
export class ViewInvoiceModal {
  @Input() order: CompanyServiceOrderResponse;

  constructor(
    private activeModal: NgbActiveModal,
    private translateService: TranslateService
  ) {}

  close() {
    this.activeModal.dismiss();
  }

  formatPrice(cents: number): string {
    return (cents / 100).toFixed(2);
  }

  getStatusClass(status: string): string {
    switch (status) {
      case 'paid':
        return 'badge-success';
      case 'pending':
        return 'badge-warning';
      case 'cancelled':
      case 'failed':
        return 'badge-danger';
      default:
        return 'badge-secondary';
    }
  }

  getPaymentTypeLabel(type: string): string {
    return type === 'subscription'
      ? this.translateService.instant('companyProfile.viewInvoiceModal.monthlySubscription')
      : this.translateService.instant('companyProfile.viewInvoiceModal.oneTimePayment');
  }

  getSubtotal(): number {
    if (!this.order.order_lines) return 0;
    return this.order.order_lines.reduce((sum, line) => sum + line.total_cents, 0);
  }

  getTotalVat(): number {
    if (!this.order.order_lines) return 0;
    return this.order.order_lines.reduce((sum, line) => sum + (line.vat_cents || 0), 0);
  }
}
